"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormSidebar = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var FormSidebar = function (_a) {
    var video = _a.video, setVideo = _a.setVideo, toggleVideoOption = _a.toggleVideoOption, user = _a.user, changed = _a.changed, setChanged = _a.setChanged;
    return react_1.default.createElement(storybook_1.Layouts.Sidebar, null,
        react_1.default.createElement(storybook_1.Videos.FormStatus, { video: video, onChange: function (hidden) { return setVideo({ hidden: hidden }); } }),
        react_1.default.createElement(storybook_1.Videos.FormComments, { video: video, toggleVideoOption: toggleVideoOption }),
        video.id && react_1.default.createElement(storybook_1.Videos.FormTags, { video: video, user: user, changed: changed, setChanged: setChanged }),
        Boolean(video.hidden) &&
            react_1.default.createElement(storybook_1.Videos.FormPublish, { video: video, onChange: function (published_at) { return setVideo({ published_at: published_at }); } }),
        video.id && react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(storybook_1.Videos.FormList, { video: video, api: 'backend', route: 'playlists', title: 'Toevoegen aan afspeellijst', params: {
                    channel_id: video.channel_id,
                    sort: 'position asc',
                    hidden: 0,
                }, onChange: setVideo }),
            react_1.default.createElement(storybook_1.Videos.FormList, { video: video, api: 'ecommerce', route: 'plans', title: 'Toevoegen aan abonnement', params: {
                    channel_id: video.channel_id,
                    hidden: 0,
                }, onChange: setVideo })),
        react_1.default.createElement(storybook_1.Forms.Thumbnail, { onChange: function (thumbnail) { return setVideo({ thumbnail: thumbnail }); }, onErrors: function (errors) { return setVideo(video, errors); }, image: video.thumbnail || 'http://cdn.jwplayer.com/v2/media/H4o9y1L6/poster.jpg?width=720' }));
};
exports.FormSidebar = FormSidebar;
